import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppConfiguration, useAppDispatch, useAppSelector } from "src/common";
import { AuthContextProvider, Loading, UIManager } from "./components/";
import Router from "./routes";
import { appActions } from "src/store";
import { RootState } from "src/store/configureStore";


function App({ config }: { config: AppConfiguration }) {
  const dispatch = useAppDispatch();
  const config_loaded = useAppSelector((state: RootState) => state.app.config);

  useEffect(() => {
    // Description: Redirect users localhost to 127.0.0.1
    if (AppConfiguration.buildForApp() && window.location.host.startsWith("localhost")) {
      const new_url = window.location.href.replace("localhost", "127.0.0.1");
      location.replace(new_url);
    } else {
      // Description: set App config and dynamically load set servers from /config endpoint - get/set build versions
      dispatch(appActions.setAppConfiguration(config.info));
      AppConfiguration.buildForApp() ?
        dispatch(appActions.getBuildVersion(config.build)) :
        dispatch(appActions.getBuildVersionComplete(config.build));
    }
  }, []);

  return !!config_loaded ?
    <BrowserRouter>
      <AuthContextProvider>
        <Router />
        <UIManager />
      </AuthContextProvider>
    </BrowserRouter> : <Loading />;
}

export default App;
